(function () {

    // *******************************************************
    // Footer - Mobile Seite für SEO
    // *******************************************************

    var strato = strato || {};
    strato.Footer = function () {

        var cnt           = '';

        $(document).ready(function () {

            // ******************************************************* for the shop footer
            (function initInfo() {

                var allPanelElems = $('.footer__info .footer__panel.footer__panel--seo');
                var allPanelElemsnot = $('.footer__info .footer__panel.footer__panel--default');

                var togglePanelIsSeoFooter = function (panel) {
                    var $panel = $(panel.currentTarget);
                    var IsSeoFooter = $panel.hasClass('footer__panel--seo');
                    var IsSeoFooterActive = $panel.hasClass('footer__info--active');

                    if (IsSeoFooter && !IsSeoFooterActive) {
                        showSeoFooter();
                    } else {
                        hideSeoFooter();
                        $panel.removeClass('footer__info--active');
                    }
                };

                var togglePanelIsnotSeoFooter = function (panel) {
                    $(panel.currentTarget).toggleClass('footer__info--active');
                };

                function showSeoFooter() {
                    $('.footer__panel--seo').each(function () {
                        $(this).addClass('footer__info--active');
                    });
                }

                function hideSeoFooter() {
                    $('.footer__panel--seo').each(function () {
                        $(this).removeClass('footer__info--active');
                    });
                }

                allPanelElems.each(function () {
                    $(this).on('click', togglePanelIsSeoFooter);
                });

                allPanelElemsnot.each(function () {
                    $(this).on('click', togglePanelIsnotSeoFooter);
                });
            }());



            // ******************************************************* for the non-shop footer
            $('.mobile footer dl').addClass('close').removeClass('col-xs-10').find('dt').click(function () {

                if ($(this).parent().hasClass('close')) {
                    $('.mobile footer dl').addClass('close');

                    if (!$(this).parent().hasClass('oneEle')) {
                        $(this).parent().removeClass('close');
                    }else {
                        $('.oneEle').removeClass('close');
                    }
                }else {
                    if (!$(this).parent().hasClass('oneEle')) {
                        $(this).parent().addClass('close');
                    }else {
                        $('.oneEle').addClass('close');
                    }
                }
            });

            $('.mobile footer dt').each(function () {
                    cnt = $(this).html();
                    if (cnt === '' || cnt.indexOf('&nbsp;') >= 0) {
                        $(this).parent().attr('class', '').addClass('oneEle').addClass('close').prev().addClass('oneEle');
                        $(this).hide();

                    }
                }
            );
        });
    };
    strato.footer = new strato.Footer();
}());
